module.exports = {"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}


//////////////////
// WEBPACK FOOTER
// ./~/web-namespaces/index.json
// module id = 718
// module chunks = 35783957827783 241767136424496